import type { SxProps, Theme } from '@mui/material'

export const upgradeTooltipStyles: Record<string, SxProps<Theme>> = {
  content: {
    display: 'flex',
    alignItems: 'center',
    gap: 0.5,
    p: 0.5,
  },
  lockIcon: {
    fontSize: 16,
  },
}
